import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client  } from '../client';

export async function productsFilter(page:number, sort: any, filter: any): Promise<[]> {
  return new AxiosRequestSender(client)
    .setUrl('products')
    .setMethod('POST')
    .setProps([{page: page, sort: sort, filter: filter}])
    .send();
}
